export const server = "UAT";

const UAT = {
  BASE_URL: "https://uat2.accruebenefits.com",
  CONFIG_BASE_URL: "https://performance-service-uat.accruebenefits.com",
  LEAVE_BASE_URL: "https://attendance-manager-uat.accruebenefits.com",
  SPOT_REWARD_BASE_URL: "https://performance-service-uat.accruebenefits.com",
  EMPLOYEE_DETAILS_BASE_URL: "https://uat2.accruebenefits.com",
  REGISTER_ASSET_BASE_URL: "https://asset-manager-uat.accruebenefits.com",
  EMPLOYEE_HELPDESK_BASE_URL: "https://helpdeskuat.accrue.club",
  CHECKLIST_BASE_URL: "https://checklist-service-uat.accruebenefits.com",
  // AwsBucket: "accrue-uat",
  // CloudFrontUrl: "https://d2t3ubjf6740pz.cloudfront.net",
  // API_SWAGGER: "https://performance-service-admin-uat.accruebenefits.com",
  // API_SWAGGER_INCENTIVE: "https://incentive-service-uat.accruebenefits.com",
};

const production = {
  BASE_URL: "https://api.accruebenefits.com",
  CONFIG_BASE_URL: "https://performance-service.accruebenefits.com",
  LEAVE_BASE_URL: "https://attendance-manager-prod.accruebenefits.com",
  SPOT_REWARD_BASE_URL: "https://performance-service.accruebenefits.com",
  EMPLOYEE_DETAILS_BASE_URL: "https://api.accruebenefits.com",
  REGISTER_ASSET_BASE_URL: "https://asset-manager-prod.accruebenefits.com",
  EMPLOYEE_HELPDESK_BASE_URL: "https://helpdeskprod.accrue.club",
  CHECKLIST_BASE_URL: "https://checklist-service-prod.accruebenefits.com",
  // AwsBucket: "accrue-prod",
  // CloudFrontUrl: "https://d1zgru07h1f99f.cloudfront.net",
  // API_SWAGGER: "https://performance-service-admin.accruebenefits.com",
  // API_SWAGGER_INCENTIVE: "https://incentive-service-prod.accruebenefits.com"
};

const config = () => {
  switch (server) {
    case "UAT":
      return UAT;
    case "production":
      return production;
    default:
      return UAT;
  }
};

export const api = config();
